import { PATH_ROOT, PATH_STRUCTURE_ASSIGNMENTS } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";
import { useStructureAssignmentsParams } from "./useStructureAssignmentsParams";

export const useStructureAssignmentsBreadcrumbs = (
  additionalItems?: (BreadcrumbItem | undefined)[],
) => {
  const { t } = useTranslation();

  const { assignmentType } = useStructureAssignmentsParams();

  return useMemo(() => {
    const breadcrumbItems: BreadcrumbItem[] = [
      {
        label: t("breadcrumb.home"),
        href: PATH_ROOT,
      },
      {
        label: t("structureAssignments.title.multiple"),
      },
      assignmentType && {
        label: t(`structureAssignments.navigation.${assignmentType}`),
        href: generatePath(PATH_STRUCTURE_ASSIGNMENTS, {
          assignmentType,
        }),
      },
    ];

    if (additionalItems && additionalItems.length > 0) {
      breadcrumbItems.push(...additionalItems.filter((item) => !!item));
    }

    return breadcrumbItems.filter(Boolean);
  }, [assignmentType, t, additionalItems]);
};
